import DatePicker, { registerLocale } from "react-datepicker";
import ja from "date-fns/locale/ja";
import i18n from "../i18n/configs";

/** 日時ピッカー - 型定義 */
type MyDataPickerProps = {
    selectedDate: Date | null;
    setDate: (date: Date | null) => void;
    placeholderText: string;
    disabled: boolean;
};

/**
 * 日時ピッカー共通コンポーネント
 * @param param0
 * @returns
 */
const MyDatePicker: React.FC<MyDataPickerProps> = ({ selectedDate, setDate, placeholderText, disabled }) => {
    registerLocale("ja", ja);

    return (
        <DatePicker
            selected={disabled ? null : selectedDate}
            onChange={(date: Date | null) => {
                setDate(date);
            }}
            disabled={disabled}
            showTimeSelect
            placeholderText={placeholderText}
            className={`${
                disabled ? "bg-gray-100 text-gray-600" : "bg-gray-50 text-gray-900"
            } mb-1 rounded-lg border border-gray-300 p-2 text-sm `}
            dateFormat={i18n.language === "ja" ? "yyyy/MM/dd HH:mm" : "dd/MM/yyyy hh:mm a"}
            locale={i18n.language === "ja" ? "ja" : undefined}
        />
    );
};

export default MyDatePicker;
